import type { AdmissionOfficeCountry } from "../../admissionOfficeCountry";
import {
  listMaltaEnAdmissionSignatures,
  templatesMaltaEnAdmissionCoursesSettings,
  templatesMaltaEnInvoiceCoursesSettings,
} from "@/src/constants/AdmissionOffice/Malta/AOMaltaEnConsts";
import {
  listPolandEnAdmissionSignatures,
  templatesPolandEnAdmissionCoursesSettings,
  templatesPolandEnInvoiceCoursesSettings,
} from "@/src/constants/AdmissionOffice/Poland/AOPolandEnConsts";
import {
  listUkraineEnAdmissionSignatures,
  templatesUkraineEnAdmissionCoursesSettings,
  templatesUkraineEnInvoiceCoursesSettings,
} from "@/src/constants/AdmissionOffice/Ukraine/AOPUkraineEnConsts";

export type AdmissionLetterBasicCourseTemplate = {
  tinyMCEContent: string;
  selected_course: string;
  medium_of_instruction: string;
  duration: string;
  title: string;
};

export type AdmissionLetterBasicInvoiceCourseTemplate = {
  tinyMCEContent: string;
};

export type AdmissionLetterBasicRegistryEntry = {
  signatures: Record<string, string>;
  admissionCourses: Record<string, AdmissionLetterBasicCourseTemplate>;
  invoiceCourses: Record<string, AdmissionLetterBasicInvoiceCourseTemplate>;
};

export const ADMISSION_LETTER_BASIC_REGISTRY: Record<AdmissionOfficeCountry, AdmissionLetterBasicRegistryEntry> = {
  malta: {
    signatures: listMaltaEnAdmissionSignatures,
    admissionCourses: templatesMaltaEnAdmissionCoursesSettings,
    invoiceCourses: templatesMaltaEnInvoiceCoursesSettings,
  },
  poland: {
    signatures: listPolandEnAdmissionSignatures,
    admissionCourses: templatesPolandEnAdmissionCoursesSettings,
    invoiceCourses: templatesPolandEnInvoiceCoursesSettings,
  },
  ukraine: {
    signatures: listUkraineEnAdmissionSignatures,
    admissionCourses: templatesUkraineEnAdmissionCoursesSettings,
    invoiceCourses: templatesUkraineEnInvoiceCoursesSettings,
  }
};
